import { useLocation } from 'react-router-dom'
import { NavFooter } from '@shared/layout/Footer'
import { shouldShowFooterForRoute } from '@shared/layout/Footer/config'

export const AppRouteFooter = () => {
	const location = useLocation()
	const shouldShowFooter = shouldShowFooterForRoute(location.pathname, location.search)

	if (!shouldShowFooter) {
		return null
	}

	return <NavFooter />
}
